import { Stack } from "@altimateai/lego";
import { ChatTriggerLink } from "@altimateai/ui-components/chatbotV2";
import { useQuery } from "@tanstack/react-query";
import { UserView } from "../types";
import { getStarterQuestions } from "@/helpers/apis";
import { isFreeStack } from "@/helpers/tenant";
import { useAppState } from "@/modules/app/useAppContext";
import { Typography } from "@altimateai/lego";

const PlaygroundStarterPrompts = ({ userView }: { userView?: UserView }) => {
  const { isDatabricksTenant } = useAppState();
  const integrationType = isDatabricksTenant ? "databricks" : isFreeStack() ? "dbt" : "snowflake";
  const { data } = useQuery({
    queryKey: ["playground-start-prompts", userView?.entity_type, userView?.path, integrationType],
    queryFn: () =>
      getStarterQuestions({
        userView,
        publicMax: 5,
        tenantMax: 0,
        integrationType,
      }),
    enabled: !!userView?.entity_type,
  });
  const starterPrompts = data?.prompts ?? [];

  if (!userView?.entity_type || (!starterPrompts.length && !data?.hello_message)) {
    return null;
  }
  return (
    <div>
      {data?.hello_message ? (
        <Typography className="al-text-gray al-border-b al-pb-4 al-mb-4">
          {data.hello_message}
        </Typography>
      ) : null}
      {starterPrompts.length ? (
        <div>
          <Typography size="xs" className="al-text-gray">
            Suggested Prompts
          </Typography>
          <Stack direction="column" className="al-mt-2">
            {starterPrompts.map(question => (
              <ChatTriggerLink
                key={question.id}
                text={question.prompt_text}
                buttonProps={{
                  variant: "outline",
                  className: "!al-rounded-full !al-text-gray al-font-normal",
                  style: { maxWidth: "fit-content" },
                }}
              />
            ))}
          </Stack>
        </div>
      ) : null}
    </div>
  );
};

export default PlaygroundStarterPrompts;
